import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './pages/Home/Home';
import Aboutus from './pages/Aboutus/Aboutus';
import Contactus from './pages/Contactus/Contactus';
import Retail from './pages/Retail/Retail';
import Hotel from './pages/Hotel/Hotel';
import Food from './pages/Food/Food';
import StartUp from './pages/Startup/Startup';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
import PrivacyAndPolicy from './pages/PrivacyAndPolicy/PrivacyAndPolicy';
import CancellationAndRefundPolicy from './pages/CancellationAndRefundPolicy/CancellationAndRefundPolicy';
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path='/products/fleet-mart' element={<Retail />} />
          <Route path='/products/fleet-stay' element={<Hotel />} />
          <Route path='/products/fleet-eats' element={<Food />} />
          <Route path='/products/fleet-office' element={<StartUp />} />
          <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
          <Route path='/privacy-and-policy' element={<PrivacyAndPolicy />} />
          <Route path='/cancellation-and-refund-policy' element={<CancellationAndRefundPolicy />} />
        </Routes>
    </BrowserRouter>
  );
}

export default App;
